import { Component, Input } from '@angular/core';

@Component({
  selector: 'call-loading-screen',
  template: `
    <h3 class="text-primary">We're calling you</h3>
    <p>
      We will now call ********{{ homeNumberEnding }}. Please get ready to make
      a note of the 6 digit OTP.
    </p>
    <div data-component="loading" [message]="'Calling...'"></div>
  `,
})
export class CallLoadingScreenComponent {
  @Input() homeNumberEnding: string;
}
